/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V2OrderErrorCode = exports.Type = exports.SyncLocationsSource = exports.State = exports.SiteCreatedContext = exports.Namespace = exports.LocaldeliveryOrderErrorCode = exports.DeleteStatus = exports.BusinessStatus = exports.AccountStatus = void 0;
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["UNKNOWN"] = "UNKNOWN";
    AccountStatus["CREATED"] = "CREATED";
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["INACTIVE"] = "INACTIVE";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
var BusinessStatus;
(function (BusinessStatus) {
    BusinessStatus["NONE"] = "NONE";
    BusinessStatus["READY"] = "READY";
    BusinessStatus["PENDING"] = "PENDING";
    BusinessStatus["ERROR"] = "ERROR";
    BusinessStatus["NOT_STARTED"] = "NOT_STARTED";
})(BusinessStatus = exports.BusinessStatus || (exports.BusinessStatus = {}));
var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
})(DeleteStatus = exports.DeleteStatus || (exports.DeleteStatus = {}));
var LocaldeliveryOrderErrorCode;
(function (LocaldeliveryOrderErrorCode) {
    LocaldeliveryOrderErrorCode["NONE"] = "NONE";
    LocaldeliveryOrderErrorCode["ALCOHOL_NOT_PERMITTED"] = "ALCOHOL_NOT_PERMITTED";
    LocaldeliveryOrderErrorCode["CASH_UNAVAILABLE"] = "CASH_UNAVAILABLE";
    LocaldeliveryOrderErrorCode["CONTACTLESS_UNAVAILABLE"] = "CONTACTLESS_UNAVAILABLE";
    LocaldeliveryOrderErrorCode["DROPOFF_ADDRESS_NOT_SERVICEABLE"] = "DROPOFF_ADDRESS_NOT_SERVICEABLE";
    LocaldeliveryOrderErrorCode["EMPTY_ORDER"] = "EMPTY_ORDER";
    LocaldeliveryOrderErrorCode["INELIGIBLE_FOR_CASH"] = "INELIGIBLE_FOR_CASH";
    LocaldeliveryOrderErrorCode["INVALID_DROPOFF_ADDRESS"] = "INVALID_DROPOFF_ADDRESS";
    LocaldeliveryOrderErrorCode["INVALID_ORDER_TOTAL"] = "INVALID_ORDER_TOTAL";
    LocaldeliveryOrderErrorCode["INVALID_PHONE_NUMBER"] = "INVALID_PHONE_NUMBER";
    LocaldeliveryOrderErrorCode["INVALID_PICKUP_ADDRESS"] = "INVALID_PICKUP_ADDRESS";
    LocaldeliveryOrderErrorCode["INVALID_PRICE"] = "INVALID_PRICE";
    LocaldeliveryOrderErrorCode["INVALID_TIP"] = "INVALID_TIP";
    LocaldeliveryOrderErrorCode["INVALID_WEIGHT_OR_VOLUME"] = "INVALID_WEIGHT_OR_VOLUME";
    LocaldeliveryOrderErrorCode["MISSING_PICKUP_OR_DELIVERY_TIME"] = "MISSING_PICKUP_OR_DELIVERY_TIME";
    LocaldeliveryOrderErrorCode["PICKUP_ADDRESS_NOT_SERVICEABLE"] = "PICKUP_ADDRESS_NOT_SERVICEABLE";
    LocaldeliveryOrderErrorCode["SYSTEM_ERROR"] = "SYSTEM_ERROR";
    LocaldeliveryOrderErrorCode["UNAVAILABLE_PICKUP_OR_DELIVERY_TIME"] = "UNAVAILABLE_PICKUP_OR_DELIVERY_TIME";
    LocaldeliveryOrderErrorCode["OTHER"] = "OTHER";
})(LocaldeliveryOrderErrorCode = exports.LocaldeliveryOrderErrorCode || (exports.LocaldeliveryOrderErrorCode = {}));
var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    Namespace["WIX"] = "WIX";
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    Namespace["ALBUMS"] = "ALBUMS";
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    Namespace["HOTELS"] = "HOTELS";
    Namespace["CLUBS"] = "CLUBS";
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    Namespace["DEV_SITE"] = "DEV_SITE";
    Namespace["LOGOS"] = "LOGOS";
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    Namespace["ANYWHERE"] = "ANYWHERE";
})(Namespace = exports.Namespace || (exports.Namespace = {}));
var SiteCreatedContext;
(function (SiteCreatedContext) {
    SiteCreatedContext["OTHER"] = "OTHER";
    SiteCreatedContext["FROM_TEMPLATE"] = "FROM_TEMPLATE";
    SiteCreatedContext["DUPLICATE_BY_SITE_TRANSFER"] = "DUPLICATE_BY_SITE_TRANSFER";
    SiteCreatedContext["DUPLICATE"] = "DUPLICATE";
    SiteCreatedContext["OLD_SITE_TRANSFER"] = "OLD_SITE_TRANSFER";
    SiteCreatedContext["FLASH"] = "FLASH";
})(SiteCreatedContext = exports.SiteCreatedContext || (exports.SiteCreatedContext = {}));
var State;
(function (State) {
    State["UNKNOWN"] = "UNKNOWN";
    State["ENABLED"] = "ENABLED";
    State["DISABLED"] = "DISABLED";
    State["PENDING"] = "PENDING";
    State["DEMO"] = "DEMO";
})(State = exports.State || (exports.State = {}));
var SyncLocationsSource;
(function (SyncLocationsSource) {
    SyncLocationsSource["API"] = "API";
    SyncLocationsSource["LOCATION_EVENT"] = "LOCATION_EVENT";
    SyncLocationsSource["RESTAURANT_PROVISIONED_EVENT"] = "RESTAURANT_PROVISIONED_EVENT";
})(SyncLocationsSource = exports.SyncLocationsSource || (exports.SyncLocationsSource = {}));
var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["FROM_ZERO_LOCATIONS_TO_ONE_LOCATION"] = "FROM_ZERO_LOCATIONS_TO_ONE_LOCATION";
    Type["FROM_ONE_LOCATION_TO_ZERO_LOCATIONS"] = "FROM_ONE_LOCATION_TO_ZERO_LOCATIONS";
})(Type = exports.Type || (exports.Type = {}));
var V2OrderErrorCode;
(function (V2OrderErrorCode) {
    V2OrderErrorCode["NONE"] = "NONE";
    V2OrderErrorCode["ALCOHOL_NOT_PERMITTED"] = "ALCOHOL_NOT_PERMITTED";
    V2OrderErrorCode["CASH_UNAVAILABLE"] = "CASH_UNAVAILABLE";
    V2OrderErrorCode["CONTACTLESS_UNAVAILABLE"] = "CONTACTLESS_UNAVAILABLE";
    V2OrderErrorCode["DROPOFF_ADDRESS_NOT_SERVICEABLE"] = "DROPOFF_ADDRESS_NOT_SERVICEABLE";
    V2OrderErrorCode["EMPTY_ORDER"] = "EMPTY_ORDER";
    V2OrderErrorCode["INELIGIBLE_FOR_CASH"] = "INELIGIBLE_FOR_CASH";
    V2OrderErrorCode["INVALID_DROPOFF_ADDRESS"] = "INVALID_DROPOFF_ADDRESS";
    V2OrderErrorCode["INVALID_ORDER_TOTAL"] = "INVALID_ORDER_TOTAL";
    V2OrderErrorCode["INVALID_PHONE_NUMBER"] = "INVALID_PHONE_NUMBER";
    V2OrderErrorCode["INVALID_PICKUP_ADDRESS"] = "INVALID_PICKUP_ADDRESS";
    V2OrderErrorCode["INVALID_PRICE"] = "INVALID_PRICE";
    V2OrderErrorCode["INVALID_TIP"] = "INVALID_TIP";
    V2OrderErrorCode["INVALID_WEIGHT_OR_VOLUME"] = "INVALID_WEIGHT_OR_VOLUME";
    V2OrderErrorCode["MISSING_PICKUP_OR_DELIVERY_TIME"] = "MISSING_PICKUP_OR_DELIVERY_TIME";
    V2OrderErrorCode["PICKUP_ADDRESS_NOT_SERVICEABLE"] = "PICKUP_ADDRESS_NOT_SERVICEABLE";
    V2OrderErrorCode["SYSTEM_ERROR"] = "SYSTEM_ERROR";
    V2OrderErrorCode["UNAVAILABLE_PICKUP_OR_DELIVERY_TIME"] = "UNAVAILABLE_PICKUP_OR_DELIVERY_TIME";
    V2OrderErrorCode["OTHER"] = "OTHER";
})(V2OrderErrorCode = exports.V2OrderErrorCode || (exports.V2OrderErrorCode = {}));
//# sourceMappingURL=types.js.map